import type { RouteMeta } from 'vue-router'

export const HITS_PER_PAGE = 32
export const HITS_PER_PAGE_WITH_BUYBACK = 31

export const COMING_SOON_INSERTION_INDEXES = [2, 15]
export const COMING_SOON_HITS_PER_PAGE = COMING_SOON_INSERTION_INDEXES.length

// Shared by the PLP, universe and seller routes so the policies cannot drift
// apart. Never add `s-maxage`, `must-revalidate` or `proxy-revalidate`: they
// disable stale serving at the edge (RFC 9111 §4.2.4).
export const PRODUCT_LIST_CACHE_POLICY =
  'public, max-age=300, stale-while-revalidate=600, stale-if-error=86400' satisfies RouteMeta['cache']
